import { useState, type FC } from 'react';
import { TextInput } from '@carbon/react';

// A DATA DE NASCIMENTO — a entrada simples de data do Carbon (o campo com o formato, sem
// calendário), que é o que o Carbon indica para datas distantes: rolar um calendário até 1990 é o motivo mais
// comum de abandono desse campo. A pessoa digita os números e as barras entram sozinhas; colar
// "23/02/1995" ou "23021995" também serve. A data só vale (ISO, AAAA-MM-DD) quando completa.

const mascarar = (bruto: string) => {
  const d = bruto.replace(/\D/g, '').slice(0, 8);
  if (d.length <= 2) return d;
  if (d.length <= 4) return `${d.slice(0, 2)}/${d.slice(2)}`;
  return `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`;
};

const paraIso = (mascarado: string) => {
  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(mascarado);
  return m ? `${m[3]}-${m[2]}-${m[1]}` : '';
};

const deIso = (iso: string) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : '';
};

export const CampoDeNascimento: FC<{
  id: string;
  valor: string;
  aoMudar: (iso: string) => void;
  /** Ao sair do campo (é quando se valida). */
  aoSair?: () => void;
  idadeMinima: number;
  invalido?: string;
}> = ({ id, valor, aoMudar, aoSair, idadeMinima, invalido }) => {
  const [texto, setTexto] = useState(() => deIso(valor));

  return (
    <TextInput
      id={id}
      labelText='Data de nascimento'
      placeholder='dd/mm/aaaa'
      inputMode='numeric'
      autoComplete='bday'
      value={texto}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        const t = mascarar(e.target.value);
        setTexto(t);
        aoMudar(paraIso(t));
      }}
      onBlur={aoSair}
      helperText={`A Maestra é destinada a maiores de ${idadeMinima} anos.`}
      invalid={!!invalido}
      invalidText={invalido}
    />
  );
};
